import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady, setAlert, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {handleChange, areFieldsValid, sanitizePayload} from 'Skelet/src/modules/functions.js'


/*
TODO:

 - ntfy bij create, van titel en username
 - enkel toestaan als profile.username is ingevuld
 - Club optie weghalen, enkel Concept of Live
 - IsArticle admin-only maken, default niet
 - img, testen met webp als input, en groter dan 300kb toestaan (ook zichtbare notitie aanpassen)
 - setAlert todo's, ook als er geen file is geüpload (mss file upload weg kunnen laten, en dan een default image tonen?)
 - ook nog een update toevoegen, en checken of dan "laatst aangepast" getoond wordt in blog
 - Author Card aanpassen naar Profile, ook rekening houden met lege velden. voor nu ipv een image de eerste letter van username als img (react-avatar)
  - bij mijn posts wel mijn image tonen
 - tekst van md support verbeteren, ook zichtbaarder maken (wil sws ook een click-to-input toevoegen)

*/

class CreateBlog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {title:"", text:"", status:"0", is_article:"0"};
  }

  render() {
    const submit_disabled = this.state.title.trim() === "" || this.state.text.trim() === "";

    return (
      <div className="card">
        <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
          <textarea value={this.state.title} onChange={(e) => handleChange(this, "title", e)} maxLength="120" placeholder="Titel"></textarea>
          <textarea value={this.state.text} onChange={(e) => handleChange(this, "text", e)} maxLength="20000" placeholder="Tekst" rows="7"></textarea>
          <div><input type="file" id="upload-file" name="upload_file" accept="image/*" /></div>
          {<div style={{marginTop:"1em", width:"100%", opacity:".5", fontSize:"10px"}}>Bestandsgrootte limiet is 600KB, en gelimiteerd tot PNG, JPG, en WEBP bestanden.</div>}
          <div>Status: <select value={this.state.status} onChange={(e) => handleChange(this, "status", e)}>
            <option key={"o1"} value="0">Concept</option>
            <option key={"o2"} value="1">Publiek</option>
            <option key={"o3"} value="2">Club</option>
          </select></div>
          <div>Artikel: <select value={this.state.is_article} onChange={(e) => handleChange(this, "is_article", e)}>
            <option key={"o2-1"} value="0">Nee</option>
            <option key={"o2-2"} value="1">Ja</option>
          </select></div>
          <div><input type="submit" value="toevoegen" disabled={submit_disabled} /></div>
        </form>
      </div>
    );
  }

  submitForm() {
    const {title, text, status, is_article} = this.state;
    const submit_disabled = title.trim() === "" || text.trim() === "";
    if(!submit_disabled) {

      let file = document.forms[0][2].files[0];
      if(file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          if(file.name.length > 240) {
            console.error("fn too long, todo:setAlert")
            return false;
          }

          if(file.type !== ("image/png") && file.type !== ("image/jpeg") && file.type !== ("image/webp")) {
            // DOMTooltip("Invalid File Type, PNG or JPEG is required.", true);
            // setTimeout(function(){DOMTooltip("");}, 3100);
            console.error("invalid type, todo:setAlert")
            return false;
          }

          let bin_blob = reader.result;
          let b_64 = btoa(bin_blob);

          if(bin_blob.length > 600000 || b_64.length > 700000) { // api handles 700kb max
            // DOMTooltip("File Size limit exceeded, 300KB is the maximum.", true);
            // setTimeout(function(){DOMTooltip("");}, 3100);
            console.error("size limit exceeded, todo:setAlert")
            return false;
          }

          let payload = {session_token:this.props.session_token, title, text, status, is_article, img_data:"data:"+file.type+";base64,"+b_64, img_type:file.type, img_name:file.name};
          let field_validation = [{dbcol:"title", name:"Titel"}, {dbcol:"text", name:"Tekst"}, {dbcol:"img_name", name:"Afbeelding"}];
          if(areFieldsValid(field_validation, payload, this.props.setAlert)) {
            payload = sanitizePayload(field_validation, payload);
            this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/blog", JSON.stringify(payload), null, true, false, true, false, false, null, "blog_list");
            this.props.clearStateBlock("blogs_overview");
            this.props.clearStateBlock("startblogs_overview");
          }
        }.bind(this);
        reader.readAsBinaryString(file);
        this.setState({title:"", text:"", status:"0", is_article:"0"});
      } // todo, club-todo: else, display a message or something :)
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateBlog)



// WEBPACK FOOTER //
// ./src/containers/CreateBlog.js